import { Component } from "react";
import * as React from "react";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { RootState } from "../../../core/reducers";
import { ThunkDispatch } from "redux-thunk";
import { withRouter, RouteComponentProps } from "react-router";
import { Button, Icon } from "antd";
import ReportByGaitApp from "../report/Report4Right";
import "../../../assets/stylesheets/component/customer.css";
import {
  getReportPageDataByUuidAndExamineeId,
  GetReportPageDataByUuidAndExamineeIdArgs,
} from "../../../core/actions/institution";

interface StateProps {}

interface DispatchProps {
  getReportPageDataByUuidAndExamineeId(args: GetReportPageDataByUuidAndExamineeIdArgs): void;
}

interface RouteParams {
  id: string;
}

type PropsType = RouteComponentProps<RouteParams> & StateProps;

class DataTrend extends Component<PropsType & DispatchProps> {
  constructor(props: any) {
    super(props);
  }

  getLangQueryString() {
    var reg = new RegExp("(^|&)language=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return "en";
  }

  componentWillMount() {
    let lang = this.getLangQueryString();
    if (lang == "en") {
      document.title = "Posture Report";
    } else {
      document.title = "体态报告";
    }
    let id = this.props.match.params.id;

    this.props.getReportPageDataByUuidAndExamineeId({
      examinationReportId: parseInt(id),
      language: lang,
    });
  }

  goPrint = () => {
    window.print();
  };

  render() {
    return (
      <div className="reportDetail">
        <ReportByGaitApp />
      </div>
    );
  }
}

function mapStateToProps(state: RootState): StateProps {
  return {};
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
  return {
    getReportPageDataByUuidAndExamineeId(args) {
      dispatch(getReportPageDataByUuidAndExamineeId(args));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DataTrend));
